export default function buildRemoveListing({
    apiEndpoint,
    apiTools
}) {
    return async function removeListing(args) {
        const url = apiTools.resolveUrl({
            ...args,
            apiEndpoint: `${ apiEndpoint }`
        })
       
        const res = await fetch(url, {
            method: 'DELETE',
            headers: {
                'Content-type': 'application/json',
            'Authorization': 'salaTokken'
            },
            credentials: 'include',
        });
        return await res.json();
    }
}